import { Link } from '@tanstack/react-router';
import { Button } from '@/components/ui/button';

export function NotFoundPage() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-background p-4 text-center">
      <h1 className="text-6xl font-bold">404</h1>
      <p className="text-muted-foreground">This route does not exist.</p>
      <Button asChild>
        <Link to="/dashboard" search={{ period: 'today' }}>
          Back to dashboard
        </Link>
      </Button>
    </div>
  );
}
